import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.messaging.chat.isLastResult;

const getIsLastResult = createSelector(getData, isLastResult => isLastResult);

export default getIsLastResult;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getIsLastResult.js